import { render, staticRenderFns } from "./indicatioveOriginalInfo.vue?vue&type=template&id=cdfdd9dc&scoped=true&"
import script from "./indicatioveOriginalInfo.vue?vue&type=script&lang=js&"
export * from "./indicatioveOriginalInfo.vue?vue&type=script&lang=js&"
import style0 from "./indicatioveOriginalInfo.vue?vue&type=style&index=0&id=cdfdd9dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfdd9dc",
  null
  
)

export default component.exports